import { render, staticRenderFns } from "./Categories.html?vue&type=template&id=2fd2cdd4&external"
import script from "./Categories.js?vue&type=script&lang=js&external"
export * from "./Categories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports